export default __webpack_public_path__ + "static/media/Mask of Acheron.b06826e4.jpg";